var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up",
    transform: "translate(-75.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrowstop-1-n_1_",
    transform: "translate(75.916 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_606",
    "data-name": "\\uD328\\uC2A4 606",
    d: "M102.816,100.046a1,1,0,0,1-.71-.3L97.155,94.8,92.2,99.746a1,1,0,0,1-1.41-1.358l5.651-5.65a1,1,0,0,1,1.414-.006l.006.006,5.651,5.65a.955.955,0,0,1-.7,1.657Z",
    transform: "translate(-90.155 -89.663)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_607",
    "data-name": "\\uD328\\uC2A4 607",
    d: "M259.114,105.381a.95.95,0,0,1-1-.893v-12.5a1,1,0,0,1,2,0v12.5A.95.95,0,0,1,259.114,105.381Z",
    transform: "translate(-252.114 -87.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_608",
    "data-name": "\\uD328\\uC2A4 608",
    d: "M88.916,2h-12a1,1,0,1,1,0-2h12a1,1,0,1,1,0,2Z",
    transform: "translate(-75.916 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTop);
export default __webpack_public_path__ + "static/media/ico_top.3378573eaa15a18c04ac34cb6fd1e763.svg";
export { ForwardRef as ReactComponent };